import { IVanPartial } from '../../../app/entities/Van'

export function createVan(van: IVanPartial, operatingStatusNote?: string) {
  return {
    url: [
      `${process.env.REACT_APP_ORIGIN}/vans`,
      `${
        operatingStatusNote ? `?operatingStatusNote=${operatingStatusNote}` : ''
      }`,
    ].join(''),
    method: 'POST',
    body: {
      ...van,
      created: undefined,
      images: undefined,
      lastDvir: undefined,
      lastMvir: undefined,
      lastWvir: undefined,
      objectId: undefined,
      order: undefined,
      outOfServiceDate: undefined,
      updated: undefined,
      vir: undefined,
    },
  }
}
export function updateVan(
  van: IVanPartial,
  operatingStatusNote?: string,
  changedBy?: string,
) {
  // BUGFIX FRON-1463: Strip VIRs from payload to prevent "Request entity too large" error
  // The backend PUT /vans endpoint does not use VIR data - it only updates core van properties
  // Removing VIRs prevents payload size issues when vans have hundreds of associated VIRs
  const { vir, ...vanWithoutVir } = van

  const queryParams = []
  if (operatingStatusNote) {
    queryParams.push(`operatingStatusNote=${encodeURIComponent(operatingStatusNote)}`)
  }
  if (changedBy) {
    queryParams.push(`changedBy=${encodeURIComponent(changedBy)}`)
  }

  return {
    url: `${process.env.REACT_APP_ORIGIN}/vans${queryParams.length ? `?${queryParams.join('&')}` : ''}`,
    method: 'PUT',
    body: vanWithoutVir,
  }
}
export function setVanToLocation(vanId: string, locationId: string) {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/locations/${locationId}/vans/${vanId}`,
    method: 'PUT',
  }
}
export const getImageBys3ObjectKey = (s3ObjectKey: string) => {
  const url = `${process.env.REACT_APP_ORIGIN}/images/byObjectKey?s3ObjectKey=${s3ObjectKey}`
  return {
    url: url,
    method: 'GET',
  }
}
